export default __webpack_public_path__ + "static/InfoDesign-dc3274838b3024b657972e8ca4856a1a.png";